import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewService,
  FormViewServiceProvider,
  vsServiceName as FormViewServiceName,
  vsProviderName as FormViewServiceProviderName,
} from "../../../../records/forms/formView";
import { RecordDataSource } from "../../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../../records/views/recordGridView";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { vsLookupManagementServiceProviderName as LookupManagementServiceProviderName } from "../../../shared/lookups";
import {
  LookupManagementConfig,
  LookupManagementServiceProvider,
} from "../../../../records/lookup/lookupManagement";
import { MachineBillValidator } from "../../models/machineConfiguration";

export const vsObjectName = "machineBillValidator";

const url = "/api/machines/MachineBillValidator";

export function machineBillValidatorLookupConfig(
  lookupManagementServiceProvider: LookupManagementServiceProvider,
  formViewServiceProvider: FormViewServiceProvider,
  recordGridViewServiceProvider: RecordGridViewServiceProvider
) {
  configureLookupManagement(lookupManagementServiceProvider);
  configureForm(formViewServiceProvider);
  recordGridViewServiceProvider.addGridConfiguration(
    vsObjectName,
    getGridConfig
  );
}
machineBillValidatorLookupConfig.$inject = [
  LookupManagementServiceProviderName,
  FormViewServiceProviderName,
  RecordGridViewServiceProviderName,
];

function configureForm(formViewServiceProvider: FormViewServiceProvider) {
  formViewServiceProvider.addFormViewConfig(vsObjectName, [
    FormViewServiceName,
    (formViewService: FormViewService): FormViewConfig => {
      return {
        fields: [
          fieldHelpers.simpleStringField({
            key: "Name",
            name: "Name",
            label: "Bv",
            required: true,
          }),
          fieldHelpers.simpleBoolField({
            key: "Disabled",
            name: "Disabled",
            label: "Disabled?",
            defaultValue: false,
          }),
        ],
        name: vsObjectName,
        submitForm: (args: FormSubmitArgs) => {
          const model = <MachineBillValidator>args.model;
          return formViewService.saveForm({
            formObject: model,
            formViewController: args.formViewController,
            url: url,
          });
        },
        title: (model: MachineBillValidator) =>
          model.Id ? "Edit Bv" : "Create Bv",
      };
    },
  ]);
}

function configureLookupManagement(
  lookupManagementServiceProvider: LookupManagementServiceProvider
) {
  lookupManagementServiceProvider.addLookup(vsObjectName, {
    displayName: "Bv",
    config: [
      ServerUtilityName,
      (serverUtility: ServerUtility): LookupManagementConfig => {
        return {
          fetchFormModel: (id: number) =>
            serverUtility.querySingle({
              url,
              query: { Id: id },
            }),
          baseUrl: url,
        };
      },
    ],
  });
}

function getGridConfig(
  serverUtility: ServerUtility,
  columnDefinitionService: ColumnDefinitionService
): GridConfiguration {
  return {
    columns: [
      columnDefinitionService.getStringColDef({
        field: "Name",
        header: "Bv",
      }),
      columnDefinitionService.getBooleanColDef({
        field: "Disabled",
      }),
    ],
    gridDataSource: new RecordDataSource(serverUtility, url),
    defaultSort: "Name",
    namePlural: "Bvs",
    nameSingular: "Bv",
    showAddButton: true,
    showAddButtonPermission: "machineLookupModify",
    showSelectButtons: false,
  };
}
getGridConfig.$inject = [ServerUtilityName, ColumnDefinitionServiceName];
